// extracted by mini-css-extract-plugin
export default {"container":"Register_container__B2+X8","register0":"Register_register0__PQ7S3","register1":"Register_register1__5rGHv","register":"Register_register__SAKSF"};